RivalIQ.apps.AdsInsights.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const AdCustomConversions = RivalIQ.data.CacheLayer.extend({
        name: 'AdCustomConversions',
        cacheKeys: [
            'adAccountId'
        ],

        loadData: function (attrs) {
            const url = [
                '/api/accounts',
                RivalIQ.state.account.get('id'),
                'insights/facebook/ads',
                attrs.adAccountId,
                'customconversions'
            ].join('/');

            return $.get(url);
        }
    });

    data.customConversions = new AdCustomConversions();
});
